export const placesMockData = [
  {
    id: 0,
    name: "Cualquier ubicacion",
    value: "Anywere"
  },

  {
    id: 1,
    name: "La Paz, Baja California Sur",
    value: "La Paz"
  },
  {
    id: 2,
    name: "Cabo San Lucas, Baja California Sur",
    value: "Los Cabos"
  },
  // {
  //   id: 3,
  //   name: "El Sargento, Baja California Sur",
  //   value: "El Sargento"
  // },
  // {
  //   id: 4,
  //   name: "Pescadero, Baja California Sur",
  //   value: "Pescadero"
  // },
]

export const testimonialsMockData = [
  {
    id: 0,
    name: "Luis",
    position: "CEO",
    company: "Land Finder México",
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, diam sit amet sodales aliquam, nunc nisl ultricies nunc, vitae aliquam nisl nunc eu nisl. Sed euismod, diam sit amet sodales aliquam, nunc nisl ultricies nunc, vitae aliquam nisl nunc eu nisl.",
    stars: 5,
    account: "@luis",
  },
  {
    id: 1,
    name: "Luis",
    position: "CEO",
    company: "Land Finder México",
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, diam sit amet sodales aliquam, nunc nisl ultricies nunc, vitae aliquam nisl nunc eu nisl. Sed euismod, diam sit amet sodales aliquam, nunc nisl ultricies nunc, vitae aliquam nisl nunc eu nisl.",
    stars: 5,
    account: "@luis",
  },
  {
    id: 2,
    name: "Luis",
    position: "CEO",
    company: "Land Finder México",
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, diam sit amet sodales aliquam, nunc nisl ultricies nunc, vitae aliquam nisl nunc eu nisl. Sed euismod, diam sit amet sodales aliquam, nunc nisl ultricies nunc, vitae aliquam nisl nunc eu nisl.",
    stars: 5,
    account: "@luis",
  },
]

export const projectTypesMockData = [
  {
    id: 1,
    name: "Todos",
    value: "Todos",
  },
  {
    id: 2,
    name: "Terreno",
    value: "Terreno",
  },
  {
    id: 3,
    name: "Edificio",
    value: "Edificio",
  },
]


export const faq = [
  {
    title: "¿Qué es una aportación?",
    description:
      "Es la acción de poner un bien inmueble a disposición de una figura legal, ya sea fideicomiso, sociedad, asociación en participación, etc., en conjunto a una parte inversionista cuyo objeto es realizar un proyecto inmobiliario y repartir sus utilidades entre las partes. ",
  },
  {
    title:
      "¿Qué características debe tener mi inmueble para ser aportado?",
    description:
      "Para cada inmueble existe un proyecto, en LFM nos encargaremos de hacer el estudio del inmueble independientemente de sus características, uso de suelo o régimen de propiedad (ejidal o privada) y darle a conocer las mejores opciones para su desarrollo. ",
  },
  {
    title:
      "¿Cuáles son los pasos para llegar al cierre de una aportación?",
    description:
      "El procedimiento en términos generales es el siguiente: (1) Se publica el inmueble en LFM. (2) El inversionista encuentra el inmueble en nuestra plataforma, se valida su registro y solicita el preanálisis de inversión. (3) El inversionista verifica la información y hace proyecciones sobre el inmueble. (4) El inversionista presenta una propuesta de aportación a LFM. (5)LFM presenta la propuesta de inversión al propietario, una vez aceptada se realiza la figura legal y se firma por ambas partes. ",
  },
  {
    title:
      "¿Puedo publicar una propiedad en trámite de regularización y/o intestado?",
    description:
      "Sí, una vez evaluada por el equipo de investigación legal se oferta la propiedad dentro de la plataforma (LFM) señalando el tipo de trámite en proceso o por realizar. ",
  },
  {
    title:
      "¿Puedo vender mi propiedad mientras se esté ofertando en LFM?",
    description:
      "Sí, la exclusiva de LFM es flexible y permite la venta del inmueble por un tercero que no requiera plazos forzosos o bien directamente por el propietario, siempre y cuando no exista una intención de inversión por parte de un fondo o desarrollador de por medio, si este fuera el caso el propietario deberá dar aviso al vendedor tercero de estas intenciones para pausar la oferta del predio. ",
  },
  {
    title:
      "¿Qué documentación se requiere para iniciar el análisis de mi propiedad?",
    description:
      "Identificación del propietario, antecedente de propiedad (título y/o escritura), oficios y/o protocolizaciones de oficios de subdivisión y/o fusión (en caso de que se haya realizado sobre el inmueble), certificado de libertad de gravamen, manifestación de construcción (en caso de que la construcción no se encuentra descrita en la escritura), contestar el cuestionario legal de validación de Land Finder México. ",
  },
  {
    title:
      "¿Qué hace distinto a LFM de otras plataformas de comercialización de inmuebles?",
    description:
      "A través de nuestro sitio, publicamos inmuebles a los cuales previamente se les realizó un preanálisis de inversión (estudios técnicos, financieros y antecedentes legales), de forma que el inversionista tenga elementos para tomar decisiones informadas, en un corto periodo de tiempo, sobre la viabilidad de un proyecto en dichos inmuebles. ",
  },
]

export const metodologiasMockData = [
  {
    id: '01',
    name: 'Due dilligence',
    detail: 'Integramos un expediente legal del inmueble y revisamos sus antecedentes.',
  },
  {
    id: '02',
    name: 'Regularización',
    detail: 'Nuestros especialistas ayudan a solucionar detalles legales o administrativos que pueda tener el inmueble. (opcional)',
  },
  {
    id: '03',
    name: 'Consultoría',
    detail: 'Investigamos el mercado para acortar la toma de decisiones para nuevos desarrollos.',
  },
  {
    id: '04',
    name: 'Estructuración',
    detail: 'Facilitamos la creación de negocios inmobiliarios a través de estudios técnicos y financieros.',
  },
  {
    id: '05',
    name: 'Publicación',
    detail: 'A través de nuestra plataforma Land Finder México promovemos la inversión en el inmueble. ',
  },
]


// --------- PARTNERS -----------
export const partners_up_part1 = [
  {
    id: 0,
    name: 'HUBi',
    image: 'HUBi.png',
    description: 'Grupo inmobiliario multidisciplinario en Baja California Sur.',
  },
  {
    id: 1,
    name: 'Welcome Home',
    image: 'Welcomehome.png',
    description: 'Comercializadora inmobiliaria especializada en proyectos.',
  },
  {
    id: 2,
    name: 'Alkilable',
    image: 'Alkilable.png',
    description: 'Administración de propiedades y proyectos habitacionales.',
  },
  {
    id: 3,
    name: 'Bantra Tech',
    image: 'BantraTech.png',
    description: 'Especialistas en tecnología proptech.',
  },
  {
    id: 4,
    name: 'Async',
    image: 'Async.png',
    description: 'Estudio de diseño especializado en marcas.',
  },
  {
    id: 5,
    name: 'Urbana',
    image: 'Urbana.png',
    description: 'Desarrollador inmobiliario.',
  },
  {
    id: 6,
    name: 'Hirales & Asociados',
    image: 'H&A.png',
    description: 'Firma legal especializada en temas inmobiliarios.',
  },
]

export const partners_up_part2 = [
  {
    id: 7,
    name: 'UKI',
    image: 'UKI.png',
    description: 'Administradora hotelera de proyectos de nicho.',
  },
  {
    id: 8,
    name: 'HUBi',
    image: 'HUBi.png',
    description: 'Grupo inmobiliario multidisciplinario en Baja California Sur.',
  },
  {
    id: 9,
    name: 'Welcome Home',
    image: 'Welcomehome.png',
    description: 'Comercializadora inmobiliaria especializada en proyectos.',
  },
  {
    id: 10,
    name: 'Alkilable',
    image: 'Alkilable.png',
    description: 'Administración de propiedades y proyectos habitacionales.',
  },
  {
    id: 11,
    name: 'Bantra Tech',
    image: 'BantraTech.png',
    description: 'Especialistas en tecnología proptech.',
  },
  {
    id: 12,
    name: 'Urbana',
    image: 'Urbana.png',
    description: 'Desarrollador inmobiliario.',
  },
  {
    id: 13,
    name: 'Hirales & Asociados',
    image: 'H&A.png',
    description: 'Firma legal especializada en temas inmobiliarios.',
  },
]

// export const partners_down_part1 = [
//   {
//     id: 10,
//     name: 'HUBi',
//     image: 'HUBi.png',
//     description: 'Grupo inmobiliario multidisciplinario en Baja California Sur.',
//   },
//   {
//     id: 11,
//     name: 'Welcome Home',
//     image: 'Welcomehome.png',
//     description: 'Comercializadora inmobiliaria especializada en proyectos.',
//   },
//   {
//     id: 12,
//     name: 'Bantra Tech',
//     image: 'BantraTech.png',
//     description: 'Especialistas en tecnología proptech.',
//   },
//   {
//     id: 13,
//     name: 'Alkilable',
//     image: 'Alkilable.png',
//     description: 'Administración de propiedades y proyectos habitacionales.',
//   },
//   {
//     id: 14,
//     name: 'UKI',
//     image: 'UKI.png',
//     description: 'Administradora hotelera de proyectos de nicho.',
//   },
//   {
//     id: 15,
//     name: 'Lobbi',
//     image: 'Lobbi-IGE.png',
//     description: 'Consultoría y gestión legal especializada en inmuebles.',
//   },
// ]

// export const partners_down_part2 = [
//   {
//     id: 16,
//     name: 'HUBi',
//     image: 'HUBi.png',
//     description: 'Grupo inmobiliario multidisciplinario en Baja California Sur.',
//   },
//   {
//     id: 17,
//     name: 'Welcome Home',
//     image: 'Welcomehome.png',
//     description: 'Comercializadora inmobiliaria especializada en proyectos.',
//   },
//   {
//     id: 18,
//     name: 'Bantra Tech',
//     image: 'BantraTech.png',
//     description: 'Especialistas en tecnología proptech.',
//   },
//   {
//     id: 19,
//     name: 'Alkilable',
//     image: 'Alkilable.png',
//     description: 'Administración de propiedades y proyectos habitacionales.',
//   },
//   {
//     id: 20,
//     name: 'UKI',
//     image: 'UKI.png',
//     description: 'Administradora hotelera de proyectos de nicho.',
//   },
//   {
//     id: 21,
//     name: 'Lobbi',
//     image: 'Lobbi-IGE.png',
//     description: 'Consultoría y gestión legal especializada en inmuebles.',
//   },
// ]
